import { createSlice } from '@reduxjs/toolkit';

import { apiGetNewsFeeds } from '@/mastodon/api/news';
import type { ApiNewsFeedJSON } from '@/mastodon/api_types/news';
import { createAppAsyncThunk } from '@/mastodon/store/typed_functions';

interface NewsFeedsState {
  items: ApiNewsFeedJSON[];
  isLoading: boolean;
  // Distinct from isLoading -- true once a fetch has settled (even if it
  // failed), so callers that need the list before they can compute a
  // correct filter (see features/news/index.tsx) know when to stop waiting.
  loaded: boolean;
}

const initialState: NewsFeedsState = {
  items: [],
  isLoading: false,
  loaded: false,
};

export const fetchNewsFeeds = createAppAsyncThunk('newsFeeds/fetch', () =>
  apiGetNewsFeeds(),
);

const newsFeedsSlice = createSlice({
  name: 'newsFeeds',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchNewsFeeds.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchNewsFeeds.fulfilled, (state, action) => {
        state.isLoading = false;
        state.loaded = true;
        state.items = action.payload;
      })
      .addCase(fetchNewsFeeds.rejected, (state) => {
        state.isLoading = false;
        state.loaded = true;
      });
  },
});

export const newsFeeds = newsFeedsSlice.reducer;
